import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import PorQuePocESetup, { POC_SETUP_META } from "@/pages/PorQuePocESetup";

export const Route = createFileRoute("/por-que-poc-e-setup")({
  head: () => buildHead({ ...POC_SETUP_META, path: "/por-que-poc-e-setup" }),
  component: PorQuePocESetup,
});
